module.exports = __webpack_public_path__ + "img/lg_ring_y_c_0_1.10021393.png";